import React from "react"
import Ample from "../components/ample"
import { Alert, AlertTitle } from '@material-ui/lab';
const CondorBuilderPage = () => (
  <Ample currPageTitle="Iron Condor Builder">
    <div className="row">
        <div className="col-md-12">
            <div className="white-box">
            
                <Alert severity="warning">
  <AlertTitle>Not Implemented</AlertTitle>
  Coming soon
</Alert>
            </div>
        </div>
        </div>
  </Ample>

)

export default CondorBuilderPage
